import { history } from 'lib/history';
import { LOGOUT_PAGE } from 'lib/routes';

export async function responseHandler<R = any>(response: Response): Promise<R> {
  if (response.status === 401 || response.status === 403) history.push(LOGOUT_PAGE);

  if (response.status >= 200 && response.status < 300) {
    const text = await response.text();
    try {
      const object = JSON.parse(text);
      return object;
    } catch (error) {
      return (text as any) as R;
    }
  }

  try {
    const text = await response.text();
    throw new Error(text || response.statusText || response.status.toString());
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    } else {
      throw new Error(error);
    }
  }
}

export async function request<R>(
  method: string,
  url: string,
  body?: object | string | number,
  headers?: Record<string, string>,
): Promise<R> {
  if (!headers) {
    headers = {};
  }

  // if the Content-Type is not set try fitting one
  if (!headers['Content-Type']) {
    switch (typeof body) {
      case 'object':
        headers['Content-Type'] = 'application/json; charset=utf-8';
        break;
      case 'string':
      case 'number':
        headers['Content-Type'] = 'text/plain; charset=utf-8';
        break;
    }
  }

  return fetch(url, {
    method,
    headers,
    body: typeof body === 'string' ? body : JSON.stringify(body),
  }).then(responseHandler);
}
